import { Customer } from '@modules/customer-store';

export const customerHasMissingFields = (customer: Customer | undefined) => {
  if (!customer) {
    return true;
  }
  if (!customer.address) {
    return true;
  }
  if (
    !customer.marketingPreferences ||
    customer.marketingPreferences.length === 0
  ) {
    return true;
  }

  return (
    !customer.telephoneNumber ||
    !customer.firstName ||
    !customer.lastName ||
    !customer.emailAddress ||
    !customer.dateOfBirth ||
    !customer.address.address1 ||
    !customer.address.town ||
    !customer.address.postCode
  );
};
